import { render, staticRenderFns } from "./CompanieTypeForm.vue?vue&type=template&id=681bec06"
import script from "./CompanieTypeForm.vue?vue&type=script&lang=js"
export * from "./CompanieTypeForm.vue?vue&type=script&lang=js"
import style0 from "./CompanieTypeForm.vue?vue&type=style&index=0&id=681bec06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports